import store from '@/store'
import {lower} from './formatting'

const sortByDate = (sortDesc, a, b) => {
  var dateA = new Date(a)
  var dateB = new Date(b)

  return sort(sortDesc, dateA, dateB)
}

const sortByCountry = (sortDesc, a, b) => {
  var lowerA = lower(store.getters['countries/getCountryById'](a).name)
  var lowerB = lower(store.getters['countries/getCountryById'](b).name)

  return sort(sortDesc, lowerA, lowerB)
}

const sortByCarrier = (sortDesc, a, b) => {
  var lowerA = lower(store.getters['tests/getCarrierById'](a).name)
  var lowerB = lower(store.getters['tests/getCarrierById'](b).name)

  return sort(sortDesc, lowerA, lowerB)
}

const sortByString = (sortBy, sortDesc, a, b) => {
  var lowerA = lower(a[sortBy])
  var lowerB = lower(b[sortBy])

  return sort(sortDesc, lowerA, lowerB)
}

const sortByProviderName = (sortDesc, a, b) => {
  var lowerA = lower(a.provider.name)
  var lowerB = lower(b.provider.name)

  return sort(sortDesc, lowerA, lowerB)
}

const sort = (sortDesc, a, b) => {
  return sortDesc ? (a < b ? -1 : 1) : (a > b ? 1 : -1)
}

const sortRate = (sortDesc, a, b) => {
  if (a === null || b === null) {
    if (a == null && b === null) {
      return 0
    }

    if (sortDesc) {
      return b === null ? 1 : -1
    } else {
      return a === null ? 1 : -1
    }
  }

  if (a === b) {
    return 0
  }

  return sortDesc ? (a < b ? -1 : 1) : (a > b ? 1 : -1)
}

export {
  sortByDate,
  sortByCountry,
  sortByCarrier,
  sortByString,
  sort,
  sortRate,
  sortByProviderName
}



// WEBPACK FOOTER //
// ./src/util/sorting.js